/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { LicenseAgreementRestService, LicenseAgreementType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { LicenseAgreementListItem } from './license-agreements.model';

@Injectable()
export class LicenseAgreementListBusinessService implements InitViewService {
  constructor(private licenseAgreementRest: LicenseAgreementRestService,
              private dictionaries: DictionaryService,
              private gridLayouts: GridLayoutService) {
  }

  initView(): any {
    return {
      licenseAgreementTypeDict: this.dictionaries.getByEnum(LicenseAgreementType),
      gridLayout: this.gridLayouts.get('licenseAgreements'),
      licenseAgreements: this.findAll(),
    };
  }

  findAll(): Observable<LicenseAgreementListItem[]> {
    return this.licenseAgreementRest.findAll();
  }
}
